<template>
<!--  顶部菜单栏-->
  <div class="navcontainer _navcontainer">
    <div class="menu_div">
      <div class="navicon _navicon"><i class="iconfont icon-caidan" @click="opencaidan()"></i></div>
      <div id="navID" class="mainnavlist _mainnavlist">
        <div class="navlistclose"><i @click="closecaidan()" class="iconfont icon-guanbi"></i></div>
        <div v-for="(item,index) in menulist" @click="routerpush(item.router)" :class="thepath==item.router?'hoverdiv':'nodiv'">
          <img v-if="index==0" src="../../assets/imgs/logo.png" />

          <p v-else >{{$i18n.locale=='zh_HK'?item.name:item.nameEn}}</p>
<!--          {{ this.valuelanguages}}-->
        </div>
      </div>
    </div>
    <div class="lang">

      <button @click="changeLanguage('en_US')" :class="this.valuelanguage=='en_US'?'Select':'NSelect'">E</button>
<!--      <button @click="changeLanguage('en_US')" class="Select">E</button>-->
      <button @click="changeLanguage('zh_HK')" :class="this.valuelanguage=='zh_HK'?'Select':'NSelect'">中</button>
    </div>
  </div>
</template>

<script>
  import {getListMenu} from '@/api/home';


  export default {
    name: 'navtop',
    components: {},
    data() {
      return {
        nalistshowflag: false,
        // langtype:localStorage.getItem("lang"),
        valuelanguage:  localStorage.getItem("lang") || 'en_US',
        menulist:'',
        thepath:this.$route.path,
      }
    },
    created() {
      this.getListMenu();

    },
    methods: {
      changeLanguage(value) {
        localStorage.setItem("lang", value);
        this.valuelanguage = localStorage.getItem("lang");
        if (
          this.valuelanguage == "null" ||
          this.valuelanguage == null ||
          this.valuelanguage == ""
        ) {
          this.valuelanguage = "zh_HK";
        }
        if (this.valuelanguage == "zh_HK") {
          this.$i18n.locale = "zh_HK";
        } else {
          this.$i18n.locale = "en_US";
        }
        this.$emit("changeL", this.valuelanguage);
        location.reload();
      },
      routerpush(to) {
        this.$router.push(to)
        location.reload();
        // 跳转之后，记得关闭菜单（在屏幕宽度小于800的时候才生效）
        var dom = document.getElementById('navID')
        if (dom.classList.contains('navlistshow')) {
          dom.classList.remove('navlistshow')
        }

      },
      //当屏幕宽度小于800的时候，点击菜单图标，显示隐藏的菜单
      opencaidan() {
        var dom = document.getElementById('navID')
        console.log(document.getElementById('navID'));
        if (dom.classList.contains('navlistshow')) {
          return
        }
        dom.classList.add('navlistshow')
      },
      //当屏幕宽度小于800的时候，点击关闭按钮， 关闭菜单
      closecaidan() {
        var dom = document.getElementById('navID')
        console.log(document.getElementById('navID'));
        if (dom.classList.contains('navlistshow')) {
          dom.classList.remove('navlistshow')
        }
      },
      //获取菜单
      getListMenu() {
        getListMenu() .then(response => {
            const data = response.data;
            this.menulist=data.data;
          })
      }
    },
  }
</script>

<style lang="less" scoped>
  // 大于800px
  @media only screen and (min-width: 800px) {
    .navcontainer {
      position: relative;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100px;
      background-color: #200A42;
      color: white;
      z-index: 99999;
      .lang {
        position: absolute;
        display: flex;
        right: 10%;
        bottom: 10%;

        button {
          margin-right: 10px;
          width: 30px;
          height: 30px;
          background-color: white;
          color: black;
          border-radius: 50%;
          text-align: center;
          line-height: 25px;
          border:none;

        }
        button:focus{
          background-color: red;
          color: white;
          border:none;
        }
        .Select{
          background-color: red;
          color: white;
          border:none;
        }
        .NSelect{
          background-color: white;
          color: black;
          border:none;
        }

      }
      .navicon {
        display: none;
        cursor: pointer;
      }

      .navicon:hover {
        color: white;
      }

      .mainnavlist {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;

        .navlistclose {
          display: none;

        }
        .nodiv{
          width: 90px;
          height: 100px;
        }
        .hoverdiv{
          width: 90px;
          height: 135px;
          p{
            margin-top: 73px;
          }
          img{
            width: 80px;
            height: 20px;
            margin-top: 75px;
          }
        }
        div {
          text-align: center;
          /*height: 150px;*/
          /*line-height: 140px;*/
          width: 90px;
          cursor: pointer;
          font-size: 18px;
          font-weight: 500;
          background-color: #2c3e50;
          margin: 0 5px;
          z-index: 9999;
          transition: all 0.3s;    //设置动画执行的时间为0.6s
          cursor: pointer;
          p{
            margin-top: 55px;
          }
          img{
            width: 75px;
            height: 20px;
            margin-top: 55px;
          }
        }

        div:nth-child(2) {
          background-color: rgba(164,85,86);
        }
        div:hover{
          transform: scale(1.05);
        }

        div:nth-child(3) {
          background-color: rgba(170,117,48);
        }

        div:nth-child(4) {
          background-color: rgba(201,165,68);
        }
        div:nth-child(5) {
          background-color: rgba(64,154,102);
        }

        div:nth-child(6) {
          background-color: rgba(29,111,149);
        }

        div:nth-child(7) {
          background-color: rgba(94,103,156);
        }

        div:nth-child(8) {
          background-color: rgba(109,90,158);
        }

        /*div:hover {*/
        /*  color: white;*/
        /*}*/
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    ._navcontainer {
      position: relative;
      top: 0;
      display: flex;
      align-items: center;
      /*justify-content: center;*/
      height: 40px;
      background-color: #200A42;
      color: white;
      z-index: 99999;
      .lang {
        position: absolute;
        display: flex;
        right: 5%;

        button {
          margin-right: 10px;
          width: 5vw;
          height:5vw;
          background-color: white;
          color: black;
          border-radius: 50%;
          text-align: center;
          line-height: 4.2vw;
          border:none;
        }
        button:focus {
          background-color: red;
          color: white;
          border:none;
        }
        .Select{
          background-color: red;
          color: white;
          border:none;
        }
        .NSelect{
          background-color: white;
          color: black;
          border:none;
        }
      }

      ._navicon {
        width: 100px;
        margin-left: -20%;
      }

      ._mainnavlist {
        display: flex;
        flex-direction: column;
        position: absolute;
        //屏幕宽度小于800，默认清空下菜单是关闭的
        display: none;
        position: fixed;
        left: 0;
        top: 0 !important;
        z-index: 1999 !important;
        padding-top: 40px !important;
        width: 100%;
        height: 100%;
        color: rgb(214, 214, 214);
        background-color: rgba(0, 0, 0, 0.95);
        top: 40px;
        padding: 0 40px;
        z-index: 999;

        div {
          text-align: left;
          height: 40px;
          line-height: 40px;
          width: 100%;
          border-bottom: 1px solid rgb(214, 214, 214);
          img{
            width: 25%;

          }
        }
      }
    }

    .navlistshow {
      display: block !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/comcomponents/NavTop.vue